import { Notification } from "../../../entity/Notification";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { NotificationDto } from "../../dto/Notification.Dto";
import { NotificationMapper } from "../../mapper/NotificationMapper";

export class WSNotification {
    private static instance: WSNotification;

    private constructor() { }

    public static getInstance(): WSNotification {
        if (!WSNotification.instance) {
            WSNotification.instance = new WSNotification();
        }
        return WSNotification.instance;
    }

    async getNotifications(storeId: string, userId: string, appVersion: string, lastNotificationId: string): Promise<Notification[] | null> {
        try {
            const url = `${ROUTES.NOTIFICATIONS}${ROUTES.GET_NOTIFICATIONS}`;

            const response = await fetchAPI<NotificationDto[]>({
                url,
                method: Method.POST,
                params: { storeId, userId, appVersion, lastNotificationId },
                isAuthenticated: true,
            });
            return response.data ? response.data.map(NotificationMapper.mapFromDto) : null;
        } catch (error) {
            console.error("Get notifications failed:", error);
            throw error;
        }
    }


    async getAllNotifications(): Promise<Notification[] | null> {
        try {
            const url = `${ROUTES.NOTIFICATIONS}${ROUTES.GET_ALL_NOTIFICATIONS}`;

            const response = await fetchAPI<NotificationDto[]>({
                url,
                method: Method.GET,
                params: {},
                isAuthenticated: true,
            });
            return response.data ? response.data.map(NotificationMapper.mapFromDto) : null;
        } catch (error) {
            console.error("Get notifications failed:", error);
            throw error;
        }
    }


    async createNotifications(notif: Notification): Promise<string> {
        try {
            const url = `${ROUTES.NOTIFICATIONS}${ROUTES.CREATE_NOTIFICATION}`;

            const response = await fetchAPI<string>({
                url,
                method: Method.POST,
                params: notif,
                isAuthenticated: true,
            });
            return response.data;
        } catch (error) {
            console.error("Create notification failed:", error);
            throw error;
        }
    }

    async deleteNotification(notificationId: string): Promise<void> {
        try {
            const url = `${ROUTES.NOTIFICATIONS}${ROUTES.DELETE_NOTIFICATION}${notificationId}`;

            await fetchAPI<void>({
                url,
                method: Method.DELETE,
                params: {},
                isAuthenticated: true,
            });
        } catch (error) {
            console.error("Delete notification failed:", error);
            throw error;
        }
    }
}


export default WSNotification.getInstance();
